import { Plus, Eye, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { formatDate } from "@/lib/api";
import { StatusPill } from "@/components/admin/shared";

const GROUPS = [
  ["categories", "Layanan", "kategori", (x) => x.name],
  ["treatments", "Harga", "harga", (x) => x.name],
  ["packages", "Paket & Promo", "paket", (x) => x.name],
  ["photos", "Dokumentasi", "dokumentasi", (x) => x.caption || "Foto tanpa caption"],
  ["testimonials", "Testimoni", "testimoni", (x) => x.name || x.text.slice(0, 40)],
  ["faqs", "FAQ", "faq", (x) => x.question],
];

const Stat = ({ label, list, onClick, k }) => (
  <button onClick={onClick} className="text-left rounded-2xl bg-white border border-nanina-line p-4 hover:border-nanina-sky transition-colors" data-testid={`overview-stat-${k}`}>
    <p className="text-[11px] font-semibold text-nanina-muted">{label}</p>
    <p className="mt-1 text-2xl font-extrabold text-nanina-green">{list.length}</p>
    <p className="text-[11px] text-nanina-muted">{list.filter((x) => x.status === "published").length} terbit · {list.filter((x) => x.status !== "published").length} belum</p>
  </button>
);

const QUICK = [["testimoni", "Tambah testimoni"], ["faq", "Tambah FAQ"], ["paket", "Tambah promo"], ["dokumentasi", "Unggah foto"], ["jadwal", "Atur jadwal"]];

export const OverviewPanel = ({ data, go }) => {
  const recent = GROUPS.flatMap(([coll, label, menu, title]) => (data[coll] || []).map((x) => ({ coll, label, menu, item: x, title: title(x) })))
    .sort((a, b) => String(b.item.updated_at || "").localeCompare(String(a.item.updated_at || ""))).slice(0, 8);
  const pending = GROUPS.reduce((n, [coll]) => n + (data[coll] || []).filter((x) => x.status !== "published" || x.has_changes).length, 0);
  return (
    <div className="space-y-6" data-testid="overview-panel">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {GROUPS.map(([coll, label, menu]) => <Stat key={coll} k={coll} label={label} list={data[coll] || []} onClick={() => go(menu)} />)}
      </div>
      <section className="rounded-2xl bg-white border border-nanina-line p-4 sm:p-5">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h2 className="text-sm font-bold text-nanina-green">Aksi cepat</h2>
          {pending > 0 && <button onClick={() => go("publish")} className="text-xs font-semibold rounded-full bg-nanina-butter/60 text-nanina-green px-3 py-1" data-testid="overview-pending-button">{pending} item belum terbit</button>}
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          {QUICK.map(([k, l]) => <button key={k} onClick={() => go(k)} className="inline-flex items-center gap-1.5 rounded-full border border-nanina-line px-3.5 py-2 text-xs font-semibold text-nanina-green hover:bg-nanina-skysoft/60" data-testid={`overview-quick-${k}`}><Plus className="h-3.5 w-3.5" /> {l}</button>)}
          <Link to="/admin/preview" target="_blank" className="inline-flex items-center gap-1.5 rounded-full bg-nanina-green text-white px-3.5 py-2 text-xs font-semibold" data-testid="overview-preview-link"><Eye className="h-3.5 w-3.5" /> Pratinjau website</Link>
        </div>
      </section>
      <section className="rounded-2xl bg-white border border-nanina-line p-4 sm:p-5">
        <h2 className="text-sm font-bold text-nanina-green">Pembaruan terbaru</h2>
        {recent.length === 0 ? <p className="mt-2 text-xs text-nanina-muted">Belum ada pembaruan.</p> : (
          <ul className="mt-2 divide-y divide-nanina-line">
            {recent.map((r) => (
              <li key={`${r.coll}-${r.item.id}`}>
                <button onClick={() => go(r.menu)} className="w-full flex flex-wrap items-center gap-2 py-2.5 text-left" data-testid={`overview-recent-${r.item.id}`}>
                  <span className="text-[10px] rounded-full bg-nanina-skysoft text-nanina-green px-2 py-0.5 font-semibold">{r.label}</span>
                  <span className="flex-1 min-w-0 text-sm text-nanina-green truncate">{r.title}</span>
                  <StatusPill item={r.item} />
                  <span className="inline-flex items-center gap-1 text-[11px] text-nanina-muted"><Clock className="h-3 w-3" />{formatDate(r.item.updated_at)}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};
